import React from 'react'
import MeetOurPastSponsors from './MeetOurPastSponsors'
import HeaderComponent from './HeaderComponent'
import Newsletter from './Newsletter'

const PastPartners = () => {
  return (
    <>
        <HeaderComponent/>
        <div>
            <MeetOurPastSponsors/>

            <Newsletter/>
        </div>
    </>
  )
}

export default PastPartners